// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

export type Props = {
	ruleLimitReached: boolean;
	limit: number;
	onClick: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class AddButton extends PureComponent<Props> {
	onClick = (_: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticsEvent, 'addRuleButton');
		this.props.onClick();
	};

	renderButton() {
		const {
			intl: { formatMessage },
			ruleLimitReached,
		} = this.props;
		return (
			<Button onClick={this.onClick} isDisabled={ruleLimitReached}>
				{formatMessage(messages.addRule)}
			</Button>
		);
	}

	render() {
		const {
			intl: { formatMessage },
			ruleLimitReached,
			limit,
		} = this.props;
		if (ruleLimitReached) {
			return (
				<Tooltip content={formatMessage(messages.limitReachedTooltip, { limit })}>
					{this.renderButton()}
				</Tooltip>
			);
		}

		return this.renderButton();
	}
}

export default injectIntl(AddButton);
